import { i18n } from 'src/i18n';
import exporterRenders from 'src/modules/shared/exporter/exporterRenders';

export default [
  {
    name: 'id',
    label: i18n('entities.eventSchedule.fields.id'),
  },
  {
    name: 'code',
    label: i18n('entities.eventSchedule.fields.code'),
  },
  {
    name: 'name',
    label: i18n('entities.eventSchedule.fields.name'),
  },
  {
    name: 'eventFrom',
    label: i18n('entities.eventSchedule.fields.eventFrom'),
  },
  {
    name: 'eventHour',
    label: i18n('entities.eventSchedule.fields.eventHour'),
  },
  {
    name: 'contacts',
    label: i18n('entities.eventSchedule.fields.contacts'),
    render: exporterRenders.relationToMany(),
  },
  {
    name: 'createdAt',
    label: i18n('entities.eventSchedule.fields.createdAt'),
    render: exporterRenders.datetime(),
  },
  {
    name: 'updatedAt',
    label: i18n('entities.eventSchedule.fields.updatedAt'),
    render: exporterRenders.datetime(),
  },
];
